var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-arrow-type01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-set\\u6700\\u65B0\\u6574\\u7406",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "images/h5/icon-set",
    transform: "translate(-66.000000, -672.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-arrow-type01",
    transform: "translate(66.000000, 672.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.10660172,16.1066017 L17.1066017,16.1066017 C17.6588865,16.1066017 18.1066017,16.554317 18.1066017,17.1066017 C18.1066017,17.6588864 17.6588865,18.1066017 17.1066017,18.1066017 L4.10660172,18.1066017 C3.83045932,18.1066017 3.58045932,17.9946729 3.39949492,17.8137085 C3.21853052,17.6327441 3.10660172,17.3827441 3.10660172,17.1066017 L3.10660172,4.10660172 C3.10660172,3.55431702 3.55431702,3.10660172 4.10660172,3.10660172 C4.65888652,3.10660172 5.10660172,3.55431702 5.10660172,4.10660172 L5.10660172,16.1066017 Z",
    id: "Combined-Shape",
    transform: "translate(10.606602, 10.606602) rotate(45.000000) translate(-10.606602, -10.606602) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/icon-arrow.d69760efd320455307d73785c87038e0.svg";
export { ForwardRef as ReactComponent };